export enum CollapsibleOptions {
  Collapsed = 1,
  Expanded = 2
}

export interface ProjectSettingsProps {
  columnsWidth?: { [propertyTraversalId: string]: number };
  /** The most recently opened views in the project, newest first. */
  recentViews?: RecentView[];
  /** When the user last opened the project (ISO 8601). */
  lastVisitedAt?: string;
}

export type SettingKey = 'gridHeader' | 'nodeDetails' | 'projectsSettings';

export type UserSettingsModel = {
  gridHeader?: CollapsibleOptions;
  nodeDetails?: CollapsibleOptions;
  projectsSettings?: { [projectId: string]: ProjectSettingsProps };
};

/** Values match the PersonalSettings `RecentViewType` enum. */
export enum RecentViewType {
  Query = 1,
  Hierarchy = 2,
  NodeList = 3
}

/** The project view header a recent view was opened under. */
export interface RecentViewPerspective {
  viewId: string;
  headerId: string;
}

/**
 * A view the user opened, stored by its ids rather than its route (see `buildRecentViewPath`). Live and proposal
 * visits of the same view share these ids, so they count as one entry.
 */
export interface RecentView {
  viewType: RecentViewType;
  /** The query id for a Query view, or the template node id for a Hierarchy or NodeList view. */
  targetId: string;
  /** Set when the view was opened under a project view header rather than from Views. */
  perspective?: RecentViewPerspective | null;
  /** Name of the view when it was opened. */
  name: string;
  templateNodeId?: string | null;
}

export type UserSettings = UserSettingsModel & {
  id: string;
  userId: string;
  databaseName: string;
  createdAt: string;
  updatedAt: string;
};
